<template>
    <div>
        <Titulo titulo="CONTACTANOS" icono="contacto"/>

        <!-- formulario de contacto -->
        <b-container>
            <b-row class="mt-5">
                <b-col cols="12" md="2"></b-col>
                <b-col cols="12" md="8">
                    <form @submit.prevent="enviarContacto" id="formContacto">
                        <!-- nombre -->
                        <b-row class="mb-2">
                            <b-col cols="12" lg="2">
                                Nombre:
                            </b-col>
                            <b-col cols="12" lg="10">
                                <b-form-input placeholder="Nombre completo..." name="nombre" required></b-form-input>
                            </b-col>
                        </b-row>
                        <!-- telefono -->
                        <b-row class="mb-2">
                            <b-col cols="12" lg="2">
                                Teléfono:
                            </b-col>
                            <b-col cols="12" lg="10">
                                <b-form-input placeholder="Teléfono" name="telefono"></b-form-input>
                            </b-col>
                        </b-row>
                        <!-- e-mail -->
                        <b-row class="mb-2">
                            <b-col cols="12" lg="2">
                                E-mail:
                            </b-col>
                            <b-col cols="12" lg="10">
                                <b-form-input type="email" placeholder="E-mail" name="email" required></b-form-input>
                            </b-col>
                        </b-row>
                        <!-- comentario -->
                        <b-row class="mb-2">
                            <b-col cols="12" lg="2">
                                Comentario:
                            </b-col>
                            <b-col cols="12" lg="10">
                                <b-form-textarea rows="3" name="comentario" required></b-form-textarea>
                            </b-col>
                        </b-row>
            
                        <div class="text-center mb-5">
                            <b-button type="submit" variant="outline-secondary"><b-icon-check-circle></b-icon-check-circle> Enviar</b-button>
                        </div>
                    </form>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import Titulo from '@/components/Titulo.vue'
import Swal from 'sweetalert2'
const axios = require('axios');
import {mapState} from 'vuex'

export default {
    name: 'Contacto',
    props: {
    },
    components: {
        Titulo
    },
    data() {
        return {
            params: {}
        }
    },
    created() {
        var formData = new FormData();
        formData.append("accion", "mostrarDatos");
        formData.append("tabla", "parametros");
        formData.append("limite", 1);
        
        axios.post(`${this.url}/ajax/ajax.generico.php`, formData)
        .then((res) => {
            this.params = res.data
        });
    },
    methods: {
        enviarContacto() {
            const form = document.getElementById('formContacto')
            var formData = new FormData(form);
            formData.append("accion", "enviarContacto");
            
            axios.post(`${this.url}/ajax/ajax.contacto.php`, formData)
            .then(res => {
                if (res.data == 'ok') {
                    Swal.fire({
                        title: 'Genial',
                        text: 'Gracias por ponerse en contacto con nosotros.',
                        icon: 'success',
                        confirmButtonText: 'Aceptar',
                        confirmButtonColor: '#3085d6',
                    })
            
                    form.reset();
                } else {
                    Swal.fire({
                        title: 'Oops',
                        text: 'Ocurrió un error al enviar el comentario, por favor intente mas tarde.',
                        icon: 'error',
                        confirmButtonText: 'Aceptar',
                        confirmButtonColor: '#3085d6',
                    })
                }
            });
        }
    },
    computed: {
        url() {
            if ( ["localhost", "127.0.0.1", ""].includes(window.location.hostname) ) {
                return this.urlSandbox
            } else {
                return this.urlProd
            }
        },
        ...mapState(['urlProd']),
        ...mapState(['urlSandbox'])
    }
}
</script>

<style scoped>
.oficinas {
    font-size: 18px;
    font-weight: bold;
}

.datoOfna {
    font-size: 12px;
}
</style>